import React, { useEffect , useState } from 'react'
import '../scss/section/header.scss';
import home from '../Component/images/home.png';
import logoname from '../Component/images/logoname.png';
import {Link} from 'react-router-dom';
import { MoreVert, ScreenLockLandscapeOutlined } from '@mui/icons-material';
import { Cancel } from '@mui/icons-material';
import Home from './Home';




export default function Header() {

  const [activeLink, setActiveLink] = useState("Bnbs");
  const [scrolled,setScrolled ] = useState(false);
  const [openNavBar, setOpenNavBar] = useState(false);



  useEffect(() => {
    const onScroll = () => {  
      if(window.scrollY > 50){
        setScrolled(true);
      }else{
        setScrolled(false)
  
      }
    }

    window.addEventListener("scroll", onscroll);
    return () =>  window.addEventListener("scroll", onscroll);
    

  }, []);

  const onUpdateActiveLink=(value) =>{
    setActiveLink(value);
    console.log(value + "is clicked");

  }
  return (
    <div className="">

        <div className='header'>
            <div className='logo'>
               <img id="logo_image" src={home}/>
                <img id="logo_name" src={logoname}/>

            </div>
            <div className= { openNavBar ? 'navBar navBar--open' :'navBar' }>
              {/* className={scrolled ? "scrolled" : ''} */}
                    <ul className="nav-list">
                          
                          <Link style={{textDecoration:'none'}} to ={`/`} >
                            <li class="nav-item"  onClick={onUpdateActiveLink}>
                                  <a className={activeLink === 'home' ? 'active navbar-Lnk': 'navbar-Link' }>Home </a>
                              </li>
                          </Link>

                          <Link style={{textDecoration:'none'}} to ={`/Bnbs`} >
                                
                              <li class="nav-item" onClick={onUpdateActiveLink}>
                                  <a className={activeLink === 'Bnbs' ? 'active navbar-Lnk': 'navbar-Link'}> Bnbs </a>
                              </li>

                          </Link>
                          <Link style={{textDecoration:'none'}} to ={`/NFTs`} >                
                              <li class="nav-item" onClick={onUpdateActiveLink}>
                                  <a className= {activeLink === 'NFTs' ? 'active navbar-Lnk': 'navbar-Link'} > NFTs </a>
                              </li>
                          </Link>
                          <Link style={{textDecoration:'none'}} to ={`/Community`} >        
                          
                              <li class="nav-item" onClick={onUpdateActiveLink}>
                                  <a className={activeLink === 'Community' ? 'active navbar-Lnk': 'navbar-Link'} >Community</a>
                              </li>
                          </Link>
                        

                                
                          <Link to ={`/ConnectWallet`} >
                          <div className='collapseButton'onClick={onUpdateActiveLink}>
                          <input type= "button" value="Connect wallet" class="connect_button" />
                          </div>
                          </Link>

                        
                    </ul>

                    

          
            </div>
          


          <div className="collapse_bar"  >
            <MoreVert onClick={()=> setOpenNavBar(
              true
            )}/>
          </div>
  
           


        </div>
    </div>
  )
}
